import { contentUnsubscribeService } from '@/data/services/content/content-unsubscribe-service'
import { queryClient } from '@/infra/http'

export async function loadContentUnsubscribe(id: string) {
  return queryClient.fetchQuery({
    queryKey: ['content-unsubscribe', id],
    queryFn: () => contentUnsubscribeService.fetchCancelReasons(id),
    staleTime: 1000
  })
}
